import {
  type ContextSelectionItem,
  type ContextSelectionType,
} from '@/components/chat/ContextSelectionContext';
import type { ToolItem } from '@/components/chat/chat-context-menu/hooks/useTools';

export const buildToolContextSelectionItem = (
  toolItem: ToolItem,
  selectedVersionIds: string[],
  selectionType: ContextSelectionType
): ContextSelectionItem => ({
  id: toolItem.id,
  title: toolItem.name,
  type: selectionType,
  lastEditLabel: toolItem.updatedAt ?? '',
  selectedVersions: selectedVersionIds,
});
